export const messages = {
  lang: "es",
  dateLocale: "es-ES",
  loading: "Cargando horas disponibles...",
  empty: "No hay horas disponibles por el momento.",
  emptyDate: "No hay horas disponibles para esta fecha.",
  appointmentTitle: "Cita",
  timezone: "Zona horaria",
  tzHourOf: "hora de",
  tzAt: "hora de",
  chooseDate: "Elija un día",
  chooseSlot: "¿Qué hora le viene bien?",
  slotsFor: "Horas del",
  pickDayFirst: "Elija un día para ver las horas disponibles.",
  slotAvailable: "Disponible",
  daySlotsOne: "{count} hora disponible",
  daySlotsMany: "{count} horas disponibles",
  formTitle: "Sus datos",
  changeSlot: "Modificar",
  back: "Volver",
  dateLabel: "Fecha",
  name: "Nombre",
  email: "Correo electrónico",
  phone: "Teléfono",
  message: "Mensaje",
  optional: "opcional",
  fieldNameRequired: "Indique su nombre.",
  fieldEmailInvalid: "Indique un correo electrónico válido.",
  fieldPhoneRequired: "Indique un número de teléfono.",
  fieldMessageRequired: "Escriba un mensaje.",
  privacyTitle: "Privacidad",
  privacyDefaultNotice: "Sus datos se utilizan únicamente para tramitar esta solicitud de cita.",
  privacyPolicyLabel: "Consultar la política de privacidad",
  submit: "Reservar cita",
  submitting: "Reservando...",
  confirmationTitle: "Cita confirmada",
  confirmationIntro: "Su hora está reservada.",
  confirmationNext: "Recibirá los detalles por correo electrónico si las notificaciones están activadas.",
  pendingTitle: "Confirme su cita",
  pendingIntro: "Su solicitud ha quedado registrada. Para confirmarla, haga clic en el enlace que le acabamos de enviar por correo electrónico.",
  pendingNext: "Si no la confirma, la hora quedará libre automáticamente. Revise también su carpeta de correo no deseado.",
  validation: "Revise los campos señalados.",
  network: "Servicio no disponible temporalmente. Vuelva a intentarlo más tarde.",
  SLOT_UNAVAILABLE: "Esta hora ya no está disponible. Elija otra.",
  VALIDATION_ERROR: "Algunos datos no son válidos. Revise el formulario.",
  CALENDAR_ERROR: "No se puede comprobar la disponibilidad en este momento.",
  EMAIL_ERROR: "La cita ha quedado registrada, pero no se ha podido enviar el correo de confirmación.",
  INTERNAL_ERROR: "Se ha producido un error técnico. Vuelva a intentarlo más tarde.",
  TENANT_NOT_FOUND: "Este servicio de reservas no está disponible.",
  RATE_LIMITED: "Demasiados intentos. Espere un momento y vuelva a intentarlo.",
  MISSING_PUBLISHABLE_KEY: "Configuración del widget incompleta (falta la clave).",
  INVALID_PUBLISHABLE_KEY: "Configuración del widget no válida (clave rechazada).",
  KEY_TENANT_MISMATCH: "Configuración del widget no válida (clave de otra cuenta).",
  ORIGIN_NOT_ALLOWED: "Este sitio no está autorizado a mostrar este widget de reservas."
};
